/**
 * Created by Rodrigo Quesada on 15/12/16.
 */
import {NgModule} from '@angular/core';
import {FileService} from './file.service';
import {FileListService} from './file-list.service';
import {FileLocation, FileLocationFactory} from './file-location.class';

@NgModule({
    providers: [FileService, FileListService, FileLocationFactory, FileLocation.InjectedMembers]
})
export class FileModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/service/file.module.ts